import { ModalAddCondReglComponent } from './../../../shared/components/modals/modal-add-cond-regl/modal-add-cond-regl.component';
import { CondReglService } from 'src/app/shared/services/simple/cond-regl.service';
import { CondReglModel } from './../../../shared/models/simple-types/cond-regl.model';
import { ReferentielDTO } from './../../../shared/dtos/referentielDTO';
import { SimpleQueryResponse } from './../../../shared/dtos/simpleQueryResponse';
import { LegacyPageEvent as PageEvent, MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { ModalInfoOkComponent } from 'src/app/shared/components/modals/info-ok/modal-info-ok.component';
import { GestionReferentielComponentService } from '../gestion-referentiel-component.service';
import { Component, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Sort } from '@angular/material/sort';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SimpleQueryUser } from 'src/app/shared/dtos/simpleQueryUser';

@Component({
  selector: 'app-gestion-cond-regl',
  templateUrl: './gestion-cond-regl.component.html',
  styleUrls: ['./gestion-cond-regl.component.scss']
})
export class GestionCondReglComponent implements OnInit {

  condRegls: CondReglModel[] = [];
  displayedColumns: string[] = ['code', 'libelle', 'mode', 'codeNTH', 'action'];
  dataSource: CondReglModel[];
  matDataSource = new MatTableDataSource<CondReglModel>();
  sortState: Sort = {active: 'code', direction: 'desc'};
  length: number;
  pageSize = 25;
  pageEvent: PageEvent;
  result: boolean;
  objet: SimpleQueryUser = new SimpleQueryUser();

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  // tslint:disable-next-line: no-output-on-prefix
  @Output() onUpdated = new EventEmitter<boolean>();

  constructor(
    public router: Router,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private toastrService: ToastrService,
    private condReglService: CondReglService,
    private gestionReferentielComponent: GestionReferentielComponentService) { }

  ngOnInit(): void {
    this.objet.query = '';
    this.objet.pageNumber = 0;
    this.objet.pageSize = this.pageSize;
    this.objet.order = 'libelle';
    this.matDataSource.paginator = this.paginator;
    this.loadPage();
  }

  onCreate(): void {
    const form = this.gestionReferentielComponent.getCreateCondReglFormGroup();
    const dialogRef = this.dialog.open(ModalAddCondReglComponent, {
        autoFocus: false,
        disableClose: true,
        data: {
          form,
          condRegls: this.condRegls,
          result: this.result
        }
      });

    dialogRef.afterClosed().subscribe(result => {
        this.onUpdated.emit(true);
        if (result) {
         this.condReglService.getAll().subscribe((condRegls: CondReglModel[]) => {
            this.dataSource = condRegls;
            this.loadPage();
          });
        }
      });

  }

  onModify(condRegl: CondReglModel): void {
    const form = this.gestionReferentielComponent.getEditCondReglFormGroup(condRegl);
    const dialogRef = this.dialog.open(ModalAddCondReglComponent, {
        autoFocus: false,
        disableClose: true,
        data: {
          form,
          condRegls: this.condRegls,
          result: this.result
        }
      });

    dialogRef.afterClosed().subscribe(result => {
        this.onUpdated.emit(true);
        if (result) {
          this.loadPage();
        }
      });
  }


  onDelete(condRegl: CondReglModel): void {
    const dialogRef = this.dialog.open(ModalInfoOkComponent, {
      data: {
        title: 'Suppression de la condition de réglement',
        message: 'Êtes-vous sur de vouloir supprimer la condition de réglement ?',
        icone: 'warning_amber',
        iconColor: 'accent',
        color: 'accent'
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.condReglService.delete(condRegl.id).subscribe((response: CondReglModel) => {
          this.toastrService.success('La condition de réglement a bien été supprimée');
          this.loadPage();
        });
      }
    });
  }


  orderUsers(condRegls: CondReglModel[]): CondReglModel[] {
    condRegls = condRegls.sort((a, b) => {
      if (a.libelle) {
        return a.libelle.localeCompare(b.libelle);
      } else {
        return -1;
      }
    });
    return condRegls;
  }

  changePage(event?: PageEvent): void {
    this.objet.pageNumber =  event.pageIndex;
    this.objet.pageSize = event.pageSize;
    this.loadPage();
  }

  search(): void {
    this.objet.pageNumber = 0;
    this.objet.pageSize = this.pageSize;
    this.paginator.pageIndex = 0;
    this.loadPage();
  }

  loadPage(): void {
    const referentiel = new ReferentielDTO();
    referentiel.objet = this.objet;
    this.condReglService.loadFromSimpleQueryAdmin(referentiel).subscribe((query: SimpleQueryResponse<CondReglModel>) => {
      if (query.objets != null) {
        this.condRegls = query.objets;
      } else {
        this.condRegls = [];
      }
      this.length = query.count;
      this.matDataSource = new MatTableDataSource<CondReglModel>(this.condRegls);
      this.paginator.length = this.length;
    });
  }

  onLeave(): void {
    this.router.navigate(['/gestion-referentiel']);
  }

  sortData(sort: Sort): void {
    if (sort.direction !== 'asc') {
      this.objet.descending = false;
    } else {
      this.objet.descending = true;
    }
    this.sortState = sort;
    this.objet.order = sort.active;
    this.loadPage();
  }
}


